import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-icones-acoes" }
const _hoisted_5 = { class: "ss-icones-acoes" }
const _hoisted_6 = { class: "ss-principais-acoes" }
const _hoisted_7 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Novo", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "ss-tela-conteudo" }
const _hoisted_11 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_12 = {
  key: 0,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 2,
  class: "acoes-item-mobile"
}
const _hoisted_17 = { class: "acoes-item" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 3,
  class: "acoes-item"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ss-acoes-massa" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Exportar", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Word", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Excel", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "CSV", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_preferencias_coluna = _resolveComponent("preferencias-coluna")!
  const _component_personalizacao_tela_modal = _resolveComponent("personalizacao-tela-modal")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_paginacao = _resolveComponent("paginacao")!
  const _component_card = _resolveComponent("card")!
  const _component_pais_modal = _resolveComponent("pais-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: _ctx.telaBase.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, {
          ExtrasTitulo: _withCtx(() => [
            (!_ctx.storeSistema.state.layoutMobile)
              ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.apresentarPersonalizacaoTela && _ctx.apresentarPersonalizacaoTela(...args)))
                            }, "Personalizar Tela")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.apresentarPersonalizarColuna && _ctx.apresentarPersonalizarColuna(...args)))
                            }, "Personalizar Colunas")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_4, [
                      _createVNode(_component_icone, { nome: "personalizacoes" })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.storeSistema.state.layoutMobile)
              ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 1 }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvarFiltrosBuscaAvancada(_ctx.telaBase.empresasSelecionadas)))
                            }, "Salvar filtros")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvarOrdenacaoBuscaAvancada(_ctx.telaBase.empresasSelecionadas)))
                            }, "Salvar ordenação")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.salvarPersonalizacaoColunas(_ctx.telaBase.empresasSelecionadas)))
                            }, "Salvar personalizações")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.salvarTodasPreferencias(_ctx.telaBase.empresasSelecionadas)))
                            }, "Salvar tudo")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redefinirPersonalizacaoColunas(_ctx.telaBase.empresasSelecionadas)))
                            }, "Redefinir personalizações")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_5, [
                      _createVNode(_component_icone, { nome: "filtro" })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Imprimir",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                }, [
                  _createVNode(_component_icone, { nome: "imprimir" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar Word",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                }, [
                  _createVNode(_component_icone, { nome: "word" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar Excel",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                }, [
                  _createVNode(_component_icone, { nome: "excel" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar CSV",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                }, [
                  _createVNode(_component_icone, { nome: "download-arquivo" })
                ]),
                (_ctx.telaBase.permissaoDados.incluir)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.novoPais && _ctx.novoPais(...args)))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_preferencias_coluna, {
            colunas: _ctx.gradeBase.colunas,
            "onUpdate:colunas": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.gradeBase.colunas) = $event)),
            visivel: _ctx.state.exibirPersonalizarColunas,
            "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.exibirPersonalizarColunas) = $event))
          }, null, 8, ["colunas", "visivel"]),
          _createVNode(_component_personalizacao_tela_modal, {
            visivel: _ctx.state.exibirPersonalizacaoTela,
            "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.exibirPersonalizacaoTela) = $event)),
            recurso: _ctx.telaBase.identificadorRecurso
          }, null, 8, ["visivel", "recurso"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_busca_geral, {
              empresas: _ctx.telaBase.empresasSelecionadas,
              ordenacao: _ctx.gradeBase.ordenacaoSelecionada,
              "onUpdate:ordenacao": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
              buscaRapida: _ctx.state.buscaRapida,
              "onUpdate:buscaRapida": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
              buscaAvancada: _ctx.gradeBase.buscaAvancada,
              "onUpdate:buscaAvancada": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
              onBuscarDados: _ctx.aplicarFiltros
            }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"]),
            _createVNode(_component_card, { titulo: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: _ctx.storeSistema.state.layoutMobile ? _ctx.gradeBase.colunasMobile : _ctx.gradeBase.colunas.filter(ColunaGrade => ColunaGrade.visible),
                  "data-source": _ctx.state.dados,
                  rowKey: "codigo",
                  pagination: false,
                  loading: _ctx.telaBase.carregando,
                  "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.preencheCodigosSelecionados },
                  size: "small"
                }, {
                  headerCell: _withCtx(({ column }) => [
                    _createVNode(_component_coluna_grade, {
                      column: column,
                      ordenacaoSelecionada: _ctx.gradeBase.ordenacaoSelecionada,
                      "onUpdate:ordenacaoSelecionada": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
                      filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                      "onUpdate:filtrosCabecalho": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                      onBuscarDados: _ctx.buscarDados
                    }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho", "onBuscarDados"])
                  ]),
                  bodyCell: _withCtx(({ column, record, text }) => [
                    ((column.key === 'Pais'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradeBase.colunas.filter(ColunaGrade => ColunaGrade.visible), (coluna) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: coluna.key
                            }, [
                              (coluna.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                    _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                    _createTextVNode(),
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.editarPais(record.codigo))
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(record[_ctx.obtemDataIndex(coluna)]), 1)
                                    ], 8, _hoisted_14)
                                  ]))
                                : (coluna.customRenderRow === _ctx.ECustomRenderRow.TagAtivo)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                      _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                      _createTextVNode(),
                                      _createVNode(_component_a_tag, {
                                        class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativo' : 'Inativo'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]))
                                  : ((coluna.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes && _ctx.gradeBase.visibilidadeColunaAcoes))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                        _createElementVNode("b", null, _toDisplayString(coluna.title), 1),
                                        _createElementVNode("div", _hoisted_17, [
                                          (_ctx.telaBase.permissaoDados.imprimir)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                title: "Imprimir",
                                                class: "imprimir",
                                                onClick: ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF, record.codigo))
                                              }, [
                                                _createVNode(_component_icone, { nome: "imprimir" })
                                              ], 8, _hoisted_18))
                                            : _createCommentVNode("", true),
                                          ((_ctx.telaBase.permissaoDados.excluir && _ctx.exibirApenasParaPainelAdministrativo()))
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                title: "Excluir",
                                                onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                                                class: "excluir"
                                              }, [
                                                _createVNode(_component_icone, { nome: "excluir" })
                                              ], 8, _hoisted_19))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                        _createTextVNode(" " + _toDisplayString(record[_ctx.obtemDataIndex(coluna)]), 1)
                                      ], 64))
                            ]))
                          }), 128))
                        ]))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.editarPais(record.codigo))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(text), 1)
                          ], 8, _hoisted_20))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.TagAtivo)
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 2,
                              class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativo' : 'Inativo'), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : ((column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes && _ctx.gradeBase.visibilidadeColunaAcoes))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_ctx.telaBase.permissaoDados.imprimir)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      title: "Imprimir",
                                      class: "imprimir",
                                      onClick: ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF, record.codigo))
                                    }, [
                                      _createVNode(_component_icone, { nome: "imprimir" })
                                    ], 8, _hoisted_22))
                                  : _createCommentVNode("", true),
                                ((_ctx.telaBase.permissaoDados.excluir && _ctx.exibirApenasParaPainelAdministrativo()))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      title: "Excluir",
                                      onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                                      class: "excluir"
                                    }, [
                                      _createVNode(_component_icone, { nome: "excluir" })
                                    ], 8, _hoisted_23))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                  ]),
                  emptyText: _withCtx(() => [
                    _createVNode(_component_mensagem_sem_dados, {
                      resultadoPesquisa: !_ctx.telaBase.carregando,
                      mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
                    }, null, 8, ["resultadoPesquisa", "mensagem"])
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading", "row-selection"]),
                _createVNode(_component_paginacao, {
                  gradeBase: _ctx.gradeBase,
                  "onUpdate:gradeBase": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.gradeBase) = $event)),
                  onBuscarDados: _ctx.buscarDados
                }, null, 8, ["gradeBase", "onBuscarDados"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    ((_ctx.gradeBase.codigosSelecionados.length > 0))
      ? (_openBlock(), _createBlock(_component_card, {
          key: 0,
          class: "ss-acoes-massa-selecionados",
          titulo: "Ações em massa"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.textoCodigosSelecionados()), 1),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.telaBase.permissaoDados.imprimir)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    title: "Imprimir",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" }),
                    _createTextVNode(" Imprimir ")
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_dropdown, null, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                          }, [
                            _createVNode(_component_icone, { nome: "word" }),
                            _createTextVNode(),
                            _hoisted_26
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                          }, [
                            _createVNode(_component_icone, { nome: "excel" }),
                            _createTextVNode(),
                            _hoisted_27
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                          }, [
                            _createVNode(_component_icone, { nome: "csv" }),
                            _createTextVNode(),
                            _hoisted_28
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (_ctx.telaBase.permissaoDados.imprimir)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                      }, [
                        _createVNode(_component_icone, { nome: "exportar" }),
                        _hoisted_25
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_pais_modal, {
      visivel: _ctx.crudBase.exibirModal,
      "onUpdate:visivel": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.crudBase.exibirModal) = $event)),
      operacao: _ctx.crudBase.operacao,
      "onUpdate:operacao": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.crudBase.operacao) = $event)),
      onSincronizarRegistro: _ctx.sincronizarPais
    }, null, 8, ["visivel", "operacao", "onSincronizarRegistro"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}